<template>
  <div class="pc-recommended-container">
    <div class="pc-recommended-inner-container" v-for="(item, index) in showRecommended" :key='index'>
      <div style="position: relative" v-if="item && item.Products.length !== 0">
        <h2 class="section-header__title" v-if="$i18n.locale == 'en'">{{item.Name}}</h2>
        <h2 class="section-header__title" v-if="$i18n.locale == 'ch'">{{item.Description}}</h2>
        <div class="afm-swiper-container">
          <swiper :options="productSwiper" ref="mySwiper">
            <swiper-slide v-for="(p, index) in item.Products" :key='index'>
              <productCard v-bind:img="p.Thumbnail"
                           v-bind:link="p.link"
                           v-bind:brand="p.Brand"
                           v-bind:rating="p.Rating"
                           v-bind:name="$i18n.locale=='en' ? p.Name : p.Description"
                           v-bind:isPromotion="p.IsPromotion"
                           v-bind:price="p.Price"
                           v-bind:item="p"
                           v-bind:inCart="inCart"
                           v-bind:quantity="p.Quantity"
                           v-bind:key="index"
              ></productCard>
            </swiper-slide>
          </swiper>
        </div>
        <div v-if="isShowButton && item.Products.length > 5" class="swiper-button-prev swp2">
          <font-awesome-icon icon="chevron-left" :style="{ color: 'black', fontSize: '20px', marginRight: '10px' }"/>
        </div>
        <div v-if="isShowButton && item.Products.length > 5" class="swiper-button-next swp2">
          <font-awesome-icon icon="chevron-right" :style="{ color: 'black', fontSize: '20px', marginLeft: '10px'  }"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productCard from "../product-card/product-card";
import {outOfStockSorts, showRecommendedData} from "../../mixin";

export default {
  name: "pc-recommended",
  mixins: [showRecommendedData, outOfStockSorts],
  components: {
    productCard,
  },
  props: {
    productSwiper: {
      type: Object,
      default: () => ({
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp2',
          prevEl: '.swiper-button-prev.swp2',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      })
    },
    isShowButton: {
      type: Boolean,
      default: () => true
    },
    inCart: {
      default: () => false
    }
  }
}
</script>

<style lang="less">
.pc-recommended-container {
  width: 100%;

  .pc-recommended-inner-container {
    width: 100%;

    .section-header__title {
      font-family: 'Raleway';
      font-size: 34px;
      font-weight: 900;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #131e1e;
    }
  }

  .swiper-container {
    --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
    --swiper-navigation-color: #00ff33; /* 单独设置按钮颜色 */
    --swiper-navigation-size: 50px; /* 设置按钮大小 */
  }

  .swiper-button-prev {
    //background-image: url("../../assets/img/arrow_left_1.png");
    background-size: 100% 100%;
    left: -6px;
  }

  .swiper-button-next {
    //background-image: url("../../assets/img/arrow_right_1.png");
    background-size: 100% 100%;
    right: -6px;
  }

  .swiper-button-prev, .swiper-button-next {
    width: 30px;
    height: 30px;
    top: 45%;
    position: absolute;
    z-index: 10;
    cursor: pointer;
  }

  .afm-swiper-container {
    padding: 0 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc-recommended/pc-recommended.vue